//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    blok: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    shouldOpenInNewTab() {
      return this.blok[0].link.target === '_blank'
    },
    shouldUseNuxtLink() {
      return this.blok[0].link.linktype === 'story' && !this.shouldOpenInNewTab
    }
  }
};
